import { render, staticRenderFns } from "./Kommentit.vue?vue&type=template&id=d3bae6f0&scoped=true"
import script from "./Kommentit.vue?vue&type=script&lang=js"
export * from "./Kommentit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bae6f0",
  null
  
)

export default component.exports